// T74 (masukan Owner 27 Okt 2026 "ok nanti diperbaikin ya , dibedakan fieldnya."): Serah Terima Tahap mencatat
// ATASAN dan CELANA terpisah di semua tahap; total = jumlah keduanya. Catatan lama (pcs gabungan) tetap terbaca.
// Seluruh pagar ada di backend (`stage_handover_service.tentukan_jenis`) — fungsi di sini hanya untuk layar.
import { LABEL_ITEM_TYPE, LABEL_PRODUK } from "./faKonfigurasi";

/** "18 atasan · 6 celana" — jenis yang 0 tidak ditulis; keduanya 0 → "0". */
export function teksJumlah(atasan, celana) {
  const a = Number(atasan) || 0;
  const c = Number(celana) || 0;
  const bagian = [];
  if (a) bagian.push(`${a} atasan`);
  if (c) bagian.push(`${c} celana`);
  return bagian.join(" · ") || "0";
}

/** Teks jumlah satu baris riwayat: berincian → "18 atasan · 6 celana", catatan lama → "24 pcs (atasan + celana)". */
export function teksJumlahBaris(h) {
  if (h && h.qty_atasan !== null && h.qty_atasan !== undefined) return teksJumlah(h.qty_atasan, h.qty_celana);
  return `${Number(h?.qty_received) || 0} pcs (atasan + celana)`;
}

/** Sisa menurut sistem untuk layar. `sisa` = jawaban GET /borongan/serah-terima/sisa. */
export function teksSisa(sisa) {
  if (!sisa) return "";
  const total = sisa.sisa ?? 0;
  if (sisa.rincian_pasti && sisa.sisa_atasan !== null && sisa.sisa_atasan !== undefined) {
    return `${total} (${teksJumlah(sisa.sisa_atasan, sisa.sisa_celana)})`;
  }
  return `${total} pcs (atasan + celana) — sebagian catatan lama tidak memisahkan atasan dan celana`;
}

/** Kotak isian yang ditampilkan: celana hanya bila FA punya celana, atasan hanya bila FA punya atasan. */
export function kolomJenis(sisa) {
  const adaAtasan = !sisa || Number(sisa.total_atasan ?? 1) > 0;
  const adaCelana = !!sisa && Number(sisa.total_celana ?? 0) > 0;
  return { atasan: adaAtasan, celana: adaCelana };
}

/**
 * Periksa isian atasan/celana sebelum dikirim (anti salah ketik). → kalimat galat, atau "" bila sah.
 * Angka melebihi sisa per jenis ditolak di layar juga; backend tetap penjaga akhirnya.
 */
export function periksaIsian(atasan, celana, sisa) {
  const a = atasan === "" || atasan === undefined ? 0 : Number(atasan);
  const c = celana === "" || celana === undefined ? 0 : Number(celana);
  if (!Number.isInteger(a) || !Number.isInteger(c) || a < 0 || c < 0) return "Jumlah atasan dan celana wajib angka bulat, tidak boleh kurang dari 0.";
  if (a + c <= 0) return "Jumlah diterima tidak boleh 0.";
  if (sisa) {
    if (a + c > (sisa.sisa ?? 0)) return `Jumlah ${a + c} melebihi sisa menurut sistem (${sisa.sisa ?? 0}).`;
    if (sisa.rincian_pasti && sisa.sisa_atasan !== null && sisa.sisa_atasan !== undefined) {
      if (a > sisa.sisa_atasan) return `${a} atasan melebihi sisa atasan (${sisa.sisa_atasan}).`;
      if (c > sisa.sisa_celana) return `${c} celana melebihi sisa celana (${sisa.sisa_celana}).`;
    }
  }
  return "";
}

/**
 * T36: "Dari tahap" terisi otomatis — tahap PERTAMA (urutan produksi) yang masih punya sisa.
 * `daftar` = [{ tahap, sisa }] berurutan. Semua habis → null (biarkan pilihan orangnya).
 */
export function tahapBerikutnya(daftar) {
  const ada = (daftar || []).find((d) => Number(d?.sisa?.sisa ?? d?.sisa ?? 0) > 0);
  return ada ? ada.tahap : null;
}

/** Label pencatat di riwayat (K229): lewat Telegram / diinput admin atas nama / layar biasa. */
export function labelPencatat(h) {
  if (!h) return "";
  if (h.dicatat_lewat === "TELEGRAM") return `Dicatat ${h.penerima_nama || "ketua tahap"} lewat Telegram`;
  if (h.penerima_employee_id) return `Diinput admin atas nama ${h.penerima_nama || "ketua tahap"}`;
  return "";
}

/** Label pembatalan: oleh koreksi (ada pengganti) atau oleh pengirimnya sendiri (Telegram). */
export function labelBatal(h) {
  if (!h?.dibatalkan_pada) return "";
  return h.dibatalkan_oleh_employee_id ? "DIBATALKAN pengirim" : "DIBATALKAN (koreksi)";
}

/**
 * T97 (titipan auditor 1 Nov 2026): label baris item FA untuk staf — "Jersey set celana hitam/putih · S", bukan kode
 * mentah. Backend mengirim `label` (teks_tampilan.baris_item); cadangan di sini untuk jawaban lama.
 */
export function labelBarisItem(it) {
  if (!it) return "—";
  if (it.label) return it.label;
  const jenis = LABEL_ITEM_TYPE[it.item_type] || LABEL_PRODUK[it.product_type]
    || (it.item_type || it.product_type ? String(it.item_type || it.product_type).replace(/_/g, " ").toLowerCase()
      .replace(/^./, (h) => h.toUpperCase()) : "Baris");
  const teks = it.size_code ? `${jenis} · ${it.size_code}` : jenis;
  return it.description ? `${teks} — ${it.description}` : teks;
}

/** T97: sisa potong satu baris item (jumlah di FA − yang sudah diserahkan). */
export function sisaBaris(it) {
  return {
    a: Math.max(0, (Number(it?.qty_atasan) || 0) - (Number(it?.sudah_atasan) || 0)),
    c: Math.max(0, (Number(it?.qty_celana) || 0) - (Number(it?.sudah_celana) || 0)),
  };
}

/** T97: isian potong per baris terisi otomatis sesuai sisa ("Semua sesuai sisa"). Baris tanpa sisa tidak diisi. */
export function potongSesuaiSisa(items) {
  const hasil = {};
  (items || []).forEach((it) => {
    const s = sisaBaris(it);
    if (s.a + s.c > 0) hasil[it.id] = { a: String(s.a), c: String(s.c) };
  });
  return hasil;
}

/** T97: label baris yang diisi DI BAWAH sisanya (peringatan — boleh, sisanya tetap menunggu). */
export function barisDiBawahSisa(items, potong) {
  return (items || []).filter((it) => {
    const s = sisaBaris(it);
    const p = potong?.[it.id] || {};
    return (Number(p.a) || 0) < s.a || (Number(p.c) || 0) < s.c;
  }).map(labelBarisItem);
}

/**
 * K235 (BUSINESS-114): kalimat untuk tahap WO yang ikut bergerak dari serah terima (jawaban `tahap_otomatis`).
 * Kosong bila tidak ada yang bergerak. `label` = { KODE: "Nama tahap" }.
 */
export function teksTahapOtomatis(t, label = {}) {
  if (!t) return "";
  const nama = (k) => label[k] || k;
  const bagian = [];
  if (t.mulai_produksi) bagian.push("produksi WO dimulai");
  if ((t.dimulai || []).length) bagian.push(`tahap ${t.dimulai.map(nama).join(" dan ")} dimulai`);
  if ((t.diselesaikan || []).length) bagian.push(`tahap ${t.diselesaikan.map(nama).join(" dan ")} selesai`);
  if (t.tertahan?.stage_code) {
    bagian.push(`tahap ${nama(t.tertahan.stage_code)} belum bisa ditutup${t.tertahan.message ? `: ${t.tertahan.message}` : ""}`);
  }
  if (!bagian.length) return "";
  const kalimat = bagian.join(", ");
  return `${kalimat.charAt(0).toUpperCase()}${kalimat.slice(1)} (otomatis dari serah terima).`;
}
